// extracted by mini-css-extract-plugin
export default {"c1Box":"C1_c1Box__ttXN1","shrinked":"C1_shrinked__8Jc7Z","backGradient":"C1_backGradient__ySSRD","textBox":"C1_textBox__sFOVo"};